<style lang="scss" src="./style.scss" scoped></style>
<script src="./script"></script>
<template>
  <h5>Thống kê COST theo brand</h5>
  <div class="card report-cost">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col col-12 col-md-5 mb-2">
          <multi-select :mappingKeys="{ label: 'name', value: 'name', description: 'code', keywords: 'code' }"
            type="string" :data="master.brands" v-model="filter.brand" size="sm"
            :style="{ width: '100%', maxWidth: '100%' }" @update:modelValue="onChangeFilter('brand')"
            :required="true" default="all"></multi-select>
        </div>
        <div class="col col-12 col-md-7 mb-2">
          <date-picker v-model="filter.date" range multi-calendars format="MM/dd/yyyy" :enable-time-picker="false"
            @update:model-value="onChangeFilter('date')">
            <template #dp-input="{ value }">
              <input type="text" placeholder="Chọn ngày" :value="value"
                class="form-control form-control-sm dp__pointer dp__input_readonly dp__input_icon_pad" />
            </template>
            <template #input-icon>
              <div style="width: 30px; text-align: center"><i class="fa-regular fa-calendar"></i></div>
            </template>
          </date-picker>
        </div>
      </div>
    </div>
    <div class="card-body">
      <overlay :loading="isLoading">
        <div class="mb-3" v-if="report && report.length > 0">
          <h6><span>Tổng cost: <span class="text-success">{{ $filters.comma(total.cost) }}</span></span> | <span>Tổng
              discount: <span class="text-success">{{ $filters.comma(total.discount) }}</span></span></h6>
        </div>
        <div class="row">
          <div class="col col-12 col-md-4" v-if="report && report.length > 0">
            <chart type="PieChart" :data="chartData" :options="chartOptions" />
          </div>
          <div class="col col-12 col-md-8">
            <div class="table-responsive border-0">
              <table class="table table-striped" v-if="report && report.length > 0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Brand</th>
                    <th>Số lượng CPD</th>
                    <th>Cost</th>
                    <th>Discount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in report" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.brand_name }}</td>
                    <td>{{ $filters.comma(item.total) }}</td>
                    <td>{{ $filters.comma(item.cost) }}</td>
                    <td>{{ $filters.comma(item.discount) }}</td>
                  </tr>
                </tbody>
              </table>
              <div v-else>Không có dữ liệu</div>
            </div>
          </div>
        </div>
      </overlay>
    </div>
  </div>
</template>